export function setAnimationFrameTimeout(callback, timeout = 0) {
    const startTime = performance.now();
    const canceller = {};
    function call() {
        canceller.id = requestAnimationFrame((now) => {
            if (now - startTime > timeout) {
                callback();
            }
            else {
                call();
            }
        });
    }
    call();
    return canceller;
}
export function clearAnimationFrameTimeout(canceller) {
    if (canceller.id)
        cancelAnimationFrame(canceller.id);
}
